/** Bump junto com server/src/modules/referrals/parceiroProgramaTermos.ts */
export const PARCEIRO_TERMOS_VERSAO = '2026-10-26.5'

export const PARCEIRO_TERMOS_TITULO = 'Regras do programa de indicação'

export const PARCEIRO_TERMOS_SECOES = [
  {
    titulo: 'Relação comercial',
    paragrafos: [
      'A relação é comercial, entre a Rocket Search e empresas ou profissionais. Não é relação de consumo.',
      'Só participa quem tem 18 anos ou mais, ou uma empresa com responsável autorizado. Os dados do cadastro são verdadeiros e atuais. Dado falso cancela o acesso e a comissão ainda não paga.',
    ],
  },
  {
    titulo: 'Quando a comissão existe',
    paragrafos: [
      'A comissão só existe se a Rocket Search fechar um cliente novo, que ainda não estava na carteira, e o pagamento do cliente compensar. Indicação duplicada, cliente que já era da carteira ou negócio perdido não gera crédito.',
      'O valor da comissão é informado depois que o acesso ao portal é aprovado. O que não for informado lá não é devido.',
      'A Rocket Search pode recusar a indicação, suspender o portal e estornar comissão obtida com fraude, lista comprada ou promessa falsa em nome da marca.',
    ],
  },
  {
    titulo: 'Dados de quem é indicado',
    paragrafos: [
      'A Rocket Search usa seu nome, o nome da sua empresa, telefone e e-mail para analisar o pedido de parceria, falar com você e, se o acesso for aprovado, criar sua conta no portal.',
      'Indicar outra pessoa ou empresa é um tratamento à parte. Você só envia nome, empresa e contato de um terceiro quando tem base lícita: a pessoa pediu a indicação, ou é um contato profissional que você conhece e que pode receber uma abordagem comercial.',
      'É proibido enviar lista comprada, base de outra empresa, dado de criança ou dado sensível, como saúde, religião, biometria ou opinião política. Este aceite não substitui a autorização da pessoa indicada.',
    ],
  },
  {
    titulo: 'Marca e responsabilidade',
    paragrafos: [
      'O participante entra como indicador. Não é representante comercial da Rocket Search, não assina por ela, não fala em nome da empresa e não usa a marca sem autorização.',
      'Se um indicado processar a empresa porque o parceiro passou o contato sem base, o parceiro responde por esse prejuízo.',
    ],
  },
  {
    titulo: 'Versão, lei e foro',
    paragrafos: [
      'A empresa pode publicar uma versão nova. O aceite antigo vale para o que já foi indicado. O uso do portal depois da nova versão vale como aceite dela.',
      'Aplica-se a lei brasileira. Fica eleito o foro da comarca de Porto Alegre, Rio Grande do Sul.',
      'Você pode pedir confirmação, correção ou exclusão dos seus dados de cadastro a partir do e-mail informado no formulário.',
    ],
  },
] as const
